<div class="flex flex-col max-w-240 md:min-w-160 max-h-screen -m-6">

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div *ngIf="data.mode === 'create'"
             class="text-lg font-medium">{{ 'Ecommerce.POS.add_to_request' | transloco }}
        </div>
        <div *ngIf="data.mode === 'edit'" class="text-lg font-medium">{{ 'Ecommerce.POS.edit_request' | transloco }}
        </div>
        <div *ngIf="data.mode === 'transfer'"
             class="text-lg font-medium">{{ 'Ecommerce.POS.transfer_request' | transloco }}
        </div>
        <button
            mat-icon-button
            (click)="saveAndClose()"
            [tabIndex]="-1">
            <mat-icon
                class="text-current"
                [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <form
        class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto"
        [formGroup]="orderSelectorForm">

        <mat-form-field *ngIf="data.mode === 'create'">
            <mat-label>{{ 'Ecommerce.POS.request' | transloco }}</mat-label>
            <mat-select [formControlName]="'order'">
                <ng-container *ngFor="let order of orders">
                    <mat-option [value]="order.id">
                        {{ order.name }}
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ 'Ecommerce.POS.quantity' | transloco }}</mat-label>
            <input
                matInput
                type="number"
                min="1"
                max="100"
                [step]="1"
                [formControlName]="'quantity'">
        </mat-form-field>


        <!-- Actions -->
        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">

            <div class="flex items-center mt-4 sm:mt-0" style="justify-content: space-between; width: 100%;">
                <!-- Cancel -->
                <button
                    class="ml-auto sm:ml-0"
                    mat-dialog-close
                    mat-stroked-button
                    (click)="discard()">
                    {{ 'cancel' | transloco }}
                </button>

                <!-- Add -->
                <button
                    class="order-first sm:order-last"
                    mat-flat-button
                    [color]="'primary'"
                    (click)="send()">
                    <span *ngIf="data.mode === 'create'">{{ 'add' | transloco }}</span>
                    <span *ngIf="data.mode === 'edit'">{{ 'edit' | transloco }}</span>
                    <span *ngIf="data.mode === 'transfer'">{{ 'transfer' | transloco }}</span>
                </button>
            </div>
        </div>
    </form>
</div>
